<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          is-blur="blur blur-rounded my-3 py-2 start-0 end-0 mx-4 shadow"
          btn-background="bg-gradient-success"
          :dark-mode="true"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-75">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-6 d-flex flex-column">
              <div class="mt-8 card card-plain">
                <div class="pb-0 card-header text-start">
                  <h3 class="font-weight-bolder text-success text-gradient">
                    欢迎回来～
                  </h3>
                  <p class="mb-0">输入账号密码登陆</p>
                </div>
                <div class="card-body">
                  <form role="form" class="text-start" @submit.prevent="handleLogin">
                    <label>账号</label>
                    <soft-input
                      v-model="loginForm.name"
                      id="name"
                      type="text"
                      placeholder="输入账号"
                      name="name"
                    />
                    <label>密码</label>
                    <soft-input
                      v-model="loginForm.password"
                      id="password"
                      type="password"
                      placeholder="输入密码"
                      name="password"
                    />
                    <soft-switch id="rememberMe" name="rememberMe" checked>
                      记住我
                    </soft-switch>
                    <div class="text-center">
                      <soft-button
                        class="my-4 mb-2"
                        variant="gradient"
                        color="success"
                        full-width
                        :loading="loading"
                        >登陆
                      </soft-button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div
                class="top-0 oblique position-absolute h-100 d-md-block d-none me-n8"
              >
                <div
                  class="bg-cover oblique-image position-absolute fixed-top ms-auto h-100 z-index-0 ms-n6"
                  :style="{
                    backgroundImage:
                      'url(' +
                      require('@/assets/img/curved-images/curved9.jpg') +
                      ')',
                  }"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer >    
  </app-footer>
</template>

<script>
import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooter from "@/examples/PageLayout/Footer.vue";
import SoftInput from "@/components/SoftInput.vue";
import SoftSwitch from "@/components/SoftSwitch.vue";
import SoftButton from "@/components/SoftButton.vue";
const body = document.getElementsByTagName("body")[0];
import { mapMutations } from "vuex";
import { mapActions } from 'vuex';

import { setToken } from '@/utils/auth'
import md5 from 'md5'
import { login } from '@/api/main'

export default {
  name: "SignIn",
  data(){
    return{
      loginForm: {
        name: '',
        password: ''
      },
      loading: false,
      redirect: null,
      otherQuery: {},
    }
  },
  methods: {
    async handleLogin(){
      console.log(this.loginForm)
      const body = {
        name: this.loginForm.name,
        password: md5(this.loginForm.password + this.loginForm.name)
      }
      try{

        const data = await login(body)
        if (data.code === 0){
          console.log("login resp:", data)
          this.$store.commit('user/SET_TOKEN',{
            id: data.userid,
            name: this.loginForm.name,
            token: data.accesstoken
          })
          setToken(JSON.stringify({
            id: data.userid,
            name: this.loginForm.name,
            token: data.accesstoken
          }))          
          //const redirect = this.redirect || '/'
          const otherQuery = this.otherQuery || {}
          console.log("set token ok. start redirect:", this.redirect)
          this.$router.push({path: "/dashboard", query: otherQuery})
        } else {
         alert(data.desc)
        }
      }catch(error) {
        alert('登陆失败，稍后再试')
      }
      
    },
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    ...mapActions('user', ['logout', 'resetToken']),
  },
  components: {
    Navbar,
    AppFooter,
    SoftInput,
    SoftSwitch,
    SoftButton,
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.remove("bg-gray-100");
    //渲染时就清理缓存
    this.logout().then(() => {
      console.log('clear token successfully')
    }).catch(error =>{
      console.log('clear cache err:', error)
    })
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
    body.classList.add("bg-gray-100");
  },
};
</script>
